<template>
    <simple-layout>
        <basic-card>
            <template slot="header">{{ $t('accountBalancesBlotter.accountBalancesBlotter') }}
                <context-help help-item-code="account-balances-blotter-view"/>
            </template>
            <template v-if="loaded">
                <form-wrapper :form-title="$t('accounts.balanceDate')">
                    <form-date-input :caption="$t('accounts.actualDate')" v-model="balancesDate"/>
                </form-wrapper>
                <div style="display: flex; flex-flow: column;">
                    <form-wrapper :columns="2" :form-title="$t('accountBalancesBlotter.toDate')">
                        <template v-if="internalAccounts.length == 0">
                            There are no active accounts
                        </template>
                        <template v-for="acc in internalAccounts" class="account-balance-entry">

                            <form-number-input :caption="acc.name" v-model="balances[acc.id].endBalance"/>


                            <simple-button @press="saveBalanceForAccount(acc.id)">
                                <icon :icon="['fal', 'save']"/>
                            </simple-button>
                            <div style="margin: 0px 10px 10px 10px;">
                                <template
                                  v-if="Math.abs($moment(balances[acc.id].balanceDate).diff(balancesDate, 'days')) > 0">
                                    (balance to date {{ new Date(balances[acc.id].balanceDate).toLocaleDateString() }})
                                </template>
                            </div>

                        </template>
                    </form-wrapper>
                    <div style="width: 20px;"></div>
                    <div>

                    </div>
                </div>
                <simple-button @press="saveBalances">
                    {{ $t('saveAll') }}
                </simple-button>
            </template>
        </basic-card>
    </simple-layout>
</template>

<script>
import SimpleLayout from "../components/layout/SimpleLayout";
import BasicCard from "../components/layout/BasicCard";
import { mapGetters } from "vuex";
import FormWrapper from "../components/form/FormWrapper";
import FormNumberInput from "../components/form/FormNumberInput";
import FormDateInput from "../components/form/FormDateInput";
import SimpleButton from "../components/button/SimpleButton";
import ContextHelp from "../components/help/ContextHelp";

export default {
    name: "AccountBalancesBlotterView",
    components: {ContextHelp, SimpleButton, FormDateInput, FormNumberInput, FormWrapper, BasicCard, SimpleLayout},
    data() {
        return {
            loaded: false,
            tmp: 0,
            balancesDate: new Date(),
            balances: {}
        }
    },
    computed: {
        ...mapGetters({"accounts": "banking/accountsByInternal", "accountBalances": "banking/accountBalances"}),
        internalAccounts() {
            return this.accounts(true).filter(acc => acc.internal && acc.active)
        }
    },
    methods: {
        saveBalanceForAccount(accId) {
            let balanceToSave = this.balances[accId];
            this.$store.dispatch("banking/saveAccountBalance", {
                account: {id: accId},
                accountBalance: {
                    ...balanceToSave,
                    balanceDate: this.balancesDate,
                    endBalance: balanceToSave.endBalance * 100
                }
            }).then(() => {
                this.refreshSingleBalance(accId);
            })
        },
        refreshSingleBalance(accId) {
            let accBalances = this.accountBalances({id: accId});
            if (accBalances == undefined) {
                accBalances = []
            }
            let lastBalanceToDate = [...accBalances]
              .sort((a, b) => this.$moment(new Date(b.balanceDate)).diff(a.balanceDate, 'days'))
              .find(bal => this.$moment(new Date(bal.balanceDate)).diff(this.balancesDate, 'days') <= 0);
            if (lastBalanceToDate == undefined) {
                lastBalanceToDate = {
                    accountId: accId,
                    startBalance: 0,
                    endBalance: 0,
                    balanceDate: this.balancesDate
                };
            }
            lastBalanceToDate = {...lastBalanceToDate}
            if (this.$moment(lastBalanceToDate.balanceDate).diff(this.balancesDate, 'days') != 0) {
                lastBalanceToDate.id = undefined;
                lastBalanceToDate.creditsByCurrency = {};
                lastBalanceToDate.debitsByCurrency = {};
            }
            lastBalanceToDate.endBalance = lastBalanceToDate.endBalance / 100;
            this.$set(this.balances, accId, lastBalanceToDate);
        },
        loadBalances() {
            this.loaded = false;
            this.internalAccounts.forEach(acc => this.refreshSingleBalance(acc.id))
            this.loaded = true;
        },
        saveBalances() {
            this.internalAccounts.forEach(acc => this.saveBalanceForAccount(acc.id))
              .then(() => {
                  this.$store.dispatch("banking/refreshAllBalances");
              })
        }
    },
    watch: {
        balancesDate() {
            this.loadBalances();
        }
    },
    mounted() {
        this.loadBalances();
    }
}
</script>

<style lang="scss" scoped>
.account-balance-entry {
    display: flex;
    flex-flow: row;
    min-width: 10%;
    flex-wrap: wrap;
    margin: 2px 5px 2px 5px;
    align-items: center;
}
</style>